import { IPickupRequestInitialState } from "../../../types/operations/pickupRequestInterface";
import { PickupRequestActionTypes, PickupRequestActions } from "../../actionTypes/operations/pickupRequestTypes";

const initialState: IPickupRequestInitialState = {
    pickupRequestList: [],
    pickupRequestData: {
        id: 0,
       // customer_id: 0,
        contact_person: "",
        contact_number: "",
       // warehouse_id: 0,
        requested_date: "",
        actual_pickup_date: null,
        status: "",
        assigned_branch: null,
        requested_time: {
            start_time: "",
            close_time: "",
        },
       // office_location_id: 0,
        total_weight: 0,
        total_pcs: 0,
        package_type: "",
        remarks: "",
        is_recurring: false,
        recurring_days: []
    },
    pickupRequestPageCount: 0,
};

export default function pickupRequestReducer(state = initialState, action: PickupRequestActionTypes): IPickupRequestInitialState {
    switch (action.type) {
        case PickupRequestActions.SET_PICKUP_REQUEST_LIST:
            return {
                ...state,
                pickupRequestList: action.payload,
            };

        case PickupRequestActions.SET_PICKUP_REQUEST_PAGE_COUNT:
            return {
                ...state,
                pickupRequestPageCount: action.payload
            };
        case PickupRequestActions.SET_PICKUP_REQUEST_DATA_BY_ID:
              return {
                ...state,
                pickupRequestData: action.payload,
              };

        default:
            return state;
    }
}
